





















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppSwitch from '@core/components/AppSwitch.vue'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import { inject } from 'inversify-props'
import { IProjectInfo } from '@master/config/IProjectInfo'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppSwitch,
    AppRadioSelection
  }
})
export default class TheBasisOfRecommendation extends Vue {
  selectedClient = 'Client 1';

  @kycFormStore.State
  kycForm!: KYCForm;

  @inject()
  private projectInfo: IProjectInfo;

  get rpa () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.rpa
    } else {
      return this.kycForm.client2.rpa
    }
  }

  get actualRiskProfile () {
    if (this.rpa.riskProfile === 'as_per_questionnaire') {
      if (this.rpa.agreement === 'no') {
        return this.beautifiedRiskProfileText(this.rpa.riskProfilePreferred)
      }
      return this.beautifiedRiskProfileText(this.rpa.riskProfileCalculated)
    }

    return this.beautifiedRiskProfileText(this.rpa.riskProfile)
  }

  get recommendations () {
    return this.kycForm.recommendations
  }

  beautifiedRiskProfileText (riskProfile: string) {
    switch (riskProfile) {
      case 'conservative':
        return 'Conservative'
      case 'moderately_conservative':
        return 'Moderately Conservative'
      case 'balanced':
        return 'Balanced'
      case 'moderately_aggressive':
        return 'Moderately Aggressive'
      case 'aggressive':
        return 'Aggressive'
      default:
        return ''
    }
  }

  get sharedBasisAttribute () {
    return this.kycForm.client1.recommendationBasis
  }

  get editingRecommendationBasis () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.recommendationBasis
    } else {
      return this.kycForm.client2.recommendationBasis
    }
  }

  clientOptionSelected (option: string): void {
    if (option === 'Client 2' && !this.isClient2Included()) {
      window.alert('Client 2 is not included in this KYC Form. To include, go to "Client Summary" page and enable the checkbox.')
      return
    }
    this.selectedClient = option
  }

  isClient2Included () {
    return this.kycForm.hasClient2
  }

  disabledTimeHorizontal () {
    if (this.editingRecommendationBasis.timeHorizonSavings === 'no' || this.editingRecommendationBasis.timeHorizonProtection === 'no') {
      return false
    }

    return true
  }

  disabledLiquidity () {
    if (this.editingRecommendationBasis.liquidityEmergencyFundsDuration === 'no' || this.editingRecommendationBasis.liquidityConsideration === 'no') {
      return false
    }

    return true
  }

  watchTimeHorizon () {
    const isAllSelectYes = [
      this.editingRecommendationBasis.timeHorizonProtection,
      this.editingRecommendationBasis.timeHorizonSavings
    ].every(value => value === 'yes' || value === 'na')

    if (isAllSelectYes) {
      this.editingRecommendationBasis.timeHorizonDeviationReason = ''
    }
  }

  watchLiquidityChanged () {
    const isAllSelectNotNo = [
      this.editingRecommendationBasis.liquidityEmergencyFundsDuration,
      this.editingRecommendationBasis.liquidityConsideration
    ].every(value => value !== 'no')

    if (isAllSelectNotNo) {
      this.editingRecommendationBasis.liquidityDeviationReason = ''
    }
  }

  @Watch('editingRecommendationBasis.timeHorizonProtection')
  onTimeHorizonProtectionChanged () {
    this.watchTimeHorizon()
  }

  @Watch('editingRecommendationBasis.timeHorizonSavings')
  onTimeHorizonSavingChanged () {
    this.watchTimeHorizon()
  }

  @Watch('editingRecommendationBasis.riskToleranceInTune')
  onRiskToleranceChanged (newVal) {
    if (newVal !== 'no') {
      this.editingRecommendationBasis.riskToleranceDeviationReason = ''
    }
  }

  @Watch('editingRecommendationBasis.liquidityEmergencyFundsDuration')
  onLiquidityEmergencyChanged () {
    this.watchLiquidityChanged()
  }

  @Watch('editingRecommendationBasis.liquidityConsideration')
  onliquidityConsiderationChanged () {
    this.watchLiquidityChanged()
  }

  @Watch('editingRecommendationBasis.productDeviationsExistence')
  onChangeBudgetReasonsFields (newVal) {
    if (newVal === 'no') {
      this.editingRecommendationBasis.productDeviationsExistenceReason = ''
    }
  }
}
